export const formatSecondsToMinutesAndSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secondsLeft = seconds % 60;

  return `${minutes}:${secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft}`;
};

export const convertMinutesToMilliseconds = (minutes) => {
  return minutes * 60 * 1000;
};

interface GroupedEmployees {
  [groupName: string]: Employee[];
}

export const groupNameMapping = {
  p3_alert: 'Priority',
  ride_ops_alert: 'Ride Ops',
  unclaimed_prio_alert: 'Ride Ops',
  great_start_alert: 'Great Start',
  lateness_alert: 'Lateness',
  specialty_transportation: 'Specialty Transportation',
  srs: 'SRS',
};

export const employeesByGroups = (employees: Employee[]): GroupedEmployees => {
  if (!employees || employees.length === 0) {
    return {};
  }

  const ungroupedEmployees = employees.filter((employee) => {
    return employee.employeeGroups && employee.employeeGroups.length === 0;
  });

  return employees.reduce((acc, employee) => {
    employee.employeeGroups.forEach((group) => {
      const mappedGroupName = groupNameMapping[group.name];

      if (!acc[mappedGroupName]) {
        acc[mappedGroupName] = [];
      }

      acc[mappedGroupName].push(employee);
    });

    acc.SRS = ungroupedEmployees;

    return acc;
  }, {} as GroupedEmployees);
};
